"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
exports.Legend = base_1.default;
var continuous_1 = require("./continuous");
exports.Size = continuous_1.Size;
exports.Color = continuous_1.Color;
var category_1 = require("./category");
exports.CanvasCategory = category_1.CanvasCategory;
exports.HtmlCategory = category_1.HtmlCategory;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/legend/index.js
// module id = 585
// module chunks = 37